/* istanbul ignore file */
import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from '@material-ui/core/styles';
import './index.css';
import { CookiesProvider } from 'react-cookie';
import App from './components/app/App';
import reportWebVitals from './reportWebVitals';
import theme from './theme';


ReactDOM.render(
  <CookiesProvider>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </CookiesProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
